var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pending_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.417 7a6.417 6.417 0 0 1-10.522 4.93l-.15.15a.584.584 0 0 1-.995-.413V10.5a.583.583 0 0 1 .583-.583H3.5a.583.583 0 0 1 .412.995l-.187.188a5.25 5.25 0 1 0-1.87-3.05.583.583 0 0 1-1.143.233A6.417 6.417 0 1 1 13.417 7M7 2.917a.583.583 0 0 0-.583.583V7A.583.583 0 0 0 7 7.583h2.917a.583.583 0 1 0 0-1.166H7.583V3.5A.583.583 0 0 0 7 2.917"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pending_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgPending;